import React from "react";
import { Box } from "@material-ui/core";
import { Tabs } from "../../components/Tabs";
import { withStyles } from "@material-ui/styles";
import { Suspense } from "react";
import LoadingDefault from "../../components/LoadingDefault";

const Debits = React.lazy(() => import("../DebitsHome"));
const ConsultaDam = React.lazy(() => import("../FindDAM"));

const styles = (theme) => ({
  container: {
    padding: "0px 15px 20px 15px",
    marginTop: "130px",
  },
});

const TabsDebits = (props) => {
  const { classes } = props;
  
  return (
    <Box className={classes.container}>
      <Tabs>
        <Tabs.Tab label={"DÉBITOS"}>
          <Suspense fallback={<LoadingDefault typeLoading="card" />}>
            <Debits {...props} />
          </Suspense>
        </Tabs.Tab>
        <Tabs.Tab label={"CONSULTAR DAM"}>
          <Suspense fallback={<LoadingDefault typeLoading="card" />}>
            <ConsultaDam typeFatherApresentation="TABS" {...props} />
          </Suspense>
        </Tabs.Tab>
      </Tabs>
    </Box>
  );
};

export default withStyles(styles, { withTheme: true })(TabsDebits);
